<!-- Base.PaginationBar.vue (client-lms) -->
<template>
  <div class="lms_pagination_bar">
    <div style="width: 80px; flex-shrink: 0;">
      <LmsBase.Select
        v-model="pageSizeModel"
        :options="sizeOptions"
        size="sm"
      />
    </div>
    <LmsBase.Pagination
      :totalCount="totalCount"
      :rowsPerPage="Number(pageSizeModel)"
      :page="props.currentPage"
      @change="onPageChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { LmsBase } from "@/common/base-components/BaseFactory";

const props = defineProps({
  totalCount: { type: Number, default: 0 },
  pageSize: { type: Number, default: 10 },
  page: { type: Number, default: 1 },
  currentPage: { type: Number, default: 1 },
  sizes: {
    type: Array as () => number[],
    default: () => [10, 20, 50, 100],
  },
});

const emit = defineEmits<{
  (e: "update:pageSize", value: number): void;
  (e: "change", page: number): void;
}>();

const pageSizeModel = ref<number>(props.pageSize);

const sizeOptions = props.sizes.map((s) => ({ label: String(s), value: s }));

watch(pageSizeModel, (val) => {
  emit("update:pageSize", Number(val));
});

const onPageChange = (page: number) => {
  emit("change", page);
};
</script>
